import { getEnv } from '@luna/env';
import { isCypressEnvironment, isFatEnvironment, isLocalEnvironment } from '@shared/environment';

function isUatWithAllowUatOverrides(): boolean {
    return !!(getEnv()?.environment === 'uat' && getEnv()?.allowUatOverrides);
}

export function areDevToolsEnabled(): boolean {
    if (isCypressEnvironment() && !window.location.hash.includes('forceOpenDevTools')) {
        return false;
    }

    return isLocalEnvironment() || isFatEnvironment() || isUatWithAllowUatOverrides();
}
